const shouldDraggableActionBeDisable = (page) => {
  return page?.meta?.navigationSubPagesSortOrder && page?.meta?.navigationSubPagesSortOrder !== "sortorder_asc";
};

export default shouldDraggableActionBeDisable;
